import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const SITE_LOGO = "https://customer-assets.emergentagent.com/job_9dd50a71-7bb8-45b9-bdec-566056107363/artifacts/kgdjrixe_Untitled%20design.png";

const SubscriptionModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    // Load HighLevel form script when modal opens
    if (isOpen) {
      const script = document.createElement('script');
      script.src = 'https://link.msgsndr.com/js/form_embed.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, [isOpen]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          onClick={onClose}
        >
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />

          {/* Modal Content */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
            data-testid="subscription-modal"
            className="relative bg-zinc-900 border border-zinc-800 rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl"
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              data-testid="close-modal-btn"
              className="absolute top-4 right-4 z-10 bg-zinc-800 hover:bg-zinc-700 text-white p-2 rounded-full transition-colors"
            >
              <X size={20} />
            </button>

            {/* Logo Only */}
            <div className="pt-6 pb-2 text-center">
              <img 
                src={SITE_LOGO}
                alt="What's Happening Baltimore"
                className="h-14 mx-auto"
              />
            </div>

            {/* HighLevel Form */}
            <div className="px-6 pb-6">
              <iframe
                src="https://api.leadconnectorhq.com/widget/form/EFE0eVc4IKlBbWMtRttX"
                style={{ width: '100%', height: '650px', border: 'none', borderRadius: '3px' }}
                id="inline-EFE0eVc4IKlBbWMtRttX"
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Subscription Form"
                data-height="650"
                data-layout-iframe-id="inline-EFE0eVc4IKlBbWMtRttX"
                data-form-id="EFE0eVc4IKlBbWMtRttX"
                title="Subscription Form"
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SubscriptionModal;
